import instance from "./endpoint";

// Get All Users (for SuperAdmin and Admin roles)
export const getUsers = async () => {
  try {
    const response = await instance.get("/api/v1/auth/getUsers");
    console.log(response.data)

    return response.data;
  } catch (error) {
    console.error("Error fetching users:", error);
    throw error;
  }
};


// Change User Role (for SuperAdmin role)
export const changeRole = async (accountID, role) => {
  try {
    const response = await instance.patch("/api/v1/auth/changeRole", {
      AccountID: accountID,
      Role: role,
    });
    console.log(response.data)

    return response.data;
  } catch (error) {
    console.error("Error changing role:", error);
    throw error;
  }
};

// Update KYC Status (for SuperAdmin role)
export const updateKYC = async (accountID, kycStatus) => {
  try {
    const response = await instance.patch("/api/v1/kycProof/kycUpdate", {
      AccountID: accountID,
      KYC_Status: kycStatus,
    });
    console.log(response.data)

    return response.data;
  } catch (error) {
    console.error("Error updating KYC:", error);
    throw error;
  }
};

// Delete User (for Admin SuperAdmin role)
export const deleteUser = async (AccountID) => {
  try {
    const response = await instance.patch("/api/v1/auth/deleteUser",{
    AccountID,
  });
    // console.log(response.data);
    return response.data;
  } catch (error) {
    console.error("Error deleting user:", error);
    throw error;
  }
};

// reactivate User (for Admin SuperAdmin role)
export const reactivateUser = async (AccountID) => {
  try {
    const response = await instance.patch("/api/v1/auth/reactivateUser",{
    AccountID,
  });
    // console.log(response.data);
    return response.data;
  } catch (error) {
    console.error("Error reactivating user:", error);
    throw error;
  }
};

// freeze User (for Admin SuperAdmin role)
export const freezeUser = async (AccountID) => {
  try {
    const response = await instance.put(`/api/v1/admin/control/freezeUser/${AccountID}`);
    return response.data;
  } catch (error) {
    console.error("Error freezing user:", error);
    throw error;
  }
};

// unfreeze User (for Admin SuperAdmin role)
export const unfreezeUser = async (AccountID) => {
  try {
    const response = await instance.put(`/api/v1/admin/control/unfreezeUser/${AccountID}`);
    return response.data;
  } catch (error) {
    console.error("Error unfreezing user:", error);
    throw error;
  }
};

// Change Withdraw Status for normal account (for SuperAdmin role)
export const changeWithdrawStatus = async (accountID, transactionID, status) => {
  try {
    const response = await instance.patch(`/api/v1/withdraw/changeStatus`, {
      AccountID: accountID,
      id: transactionID,
      status: status,
    });
    console.log(response.data)

    return response.data;
  } catch (error) {
    console.error("Error changing withdraw status:", error);
    throw error;
  }
};

// Change Withdraw Status for old age account (for SuperAdmin role)
export const changeOldAgeWithdrawStatus = async (accountID, transactionID, status, month, amount) => {
  try {
    const response = await instance.patch(`/api/v1/withdraw/changeStatusOldAgeWithdraw`, {
      AccountID: accountID,
      id: transactionID,
      status: status,
      month: month,
      amount: amount,
    });
    console.log(response.data)

    return response.data;
  } catch (error) {
    console.error("Error changing withdraw status:", error);
    throw error;
  }
};
// Change final Withdraw Status for old age account (for SuperAdmin role)
export const changeOldAgeFinalWithdrawStatus = async (accountID, transactionID, status) => {
  try {
    const response = await instance.patch(`/api/v1/withdraw/changeStatusDepositWithdrawOldAge`, {
      AccountID: accountID,
      id: transactionID,
      status: status,
    });
    console.log(response.data)

    return response.data;
  } catch (error) {
    console.error("Error changing withdraw status:", error);
    throw error;
  }
};

// Change Deposit Status (for SuperAdmin role)
export const changeDepositStatus = async (accountID, transactionID, status, return_percentage, withdrawPeriod) => {
  try {
    const response = await instance.patch("/api/v1/deposit/changeStatus", {
      AccountID: accountID,
      id: transactionID,
      status: status,
      return_percentage: return_percentage,
      withdrawPeriod: withdrawPeriod
    });
    console.log(response.data)

    return response.data;
  } catch (error) {
    console.error("Error changing deposit status:", error);
    throw error;
  }
};
